<img loading="lazy" data-src="/assets/images/homepage/success-img.svg" class="sucess-img" alt="Lead success icon" />
<h1>Thank you for sharing your details!<br />
  We will get back to you soon!<br/>
  You can also reach out to us at +91 {{variablesService.contactUsMobNumber}}
</h1>